export const defaultTime = '9:00';

export const defaultTimeZone = 'Asia/Jerusalem';

export const STEPS = {
  ADD_ROLE: 'add_role',
  ADD_SENIORITY: 'add_seniority',
  ADD_INTERESTS: 'add_interests',
  ADD_WORK_HOURS: 'add_work_hours'
};

export const STEPS_ORDER = [
  STEPS.ADD_ROLE,
  STEPS.ADD_SENIORITY,
  STEPS.ADD_INTERESTS,
  STEPS.ADD_WORK_HOURS
];

